module.exports = {"371771001":"丹阳街道","371771002":"岳程街道","371771003":"佃户屯街道","371771101":"陈集镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371771.json
// module id = 1630
// module chunks = 0